import { DashBoardRes } from '../types';
import { Dashicon1 } from '@/assets/img/dash-icon-1';
import { Dashicon2 } from '@/assets/img/dash-icon-2';
import { Dashicon3 } from '@/assets/img/dash-icon-3';
import { Dashicon4 } from '@/assets/img/dash-icon-4';
import { Heading } from '@/components/Elements/Heading';
import { formatValue } from 'react-currency-input-field';
import { ReactComponent as DownArrow } from '@/assets/img/down-arrow.svg';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export type AnalyticsDataProps = {
  analyticsData: DashBoardRes | undefined;
  isRoomBooking: boolean;
};
export const AnalyticsData = ({ analyticsData, isRoomBooking }: AnalyticsDataProps) => {
  const [showData, setShowData] = useState(false);
  const { t, i18n } = useTranslation();
  const onShowClick = () => {
    setShowData(!showData);
  };
  return (
    <div className="appointment-analytics">
      <div className="top-nav-analytics">
        <Heading title={t('Business Growth')} description="" size="sm" />
        <DownArrow className={`down-icon  ${showData ? 'show' : 'hide'}`} onClick={onShowClick} />
      </div>
      {analyticsData && (
        <div className={`dashboard-info-row ${showData ? 'show' : 'hide'}`}>
          <DashboardCard
            label={t('estimated revenue')}
            value={formatValue({
              value: '' + Number(analyticsData?.revenue ? analyticsData?.revenue : 0).toFixed(2),
              groupSeparator: ',',
              decimalSeparator: '.',
              prefix: '$',
            })}
            statsPercentage={Number(analyticsData?.revPerc)}
            statsDescription={t('than last quarter')}
            cardClassName="card-1"
            icon={<Dashicon1 />}
            unit={''}
          />
          <DashboardCard
            label={isRoomBooking ? t('hours booked') : t('hours serviced')}
            value={formatValue({
              value:
                '' +
                Number(analyticsData?.hoursServiced ? analyticsData?.hoursServiced : 0).toFixed(),
              groupSeparator: ',',
              decimalSeparator: '.',
              prefix: '',
            })}
            statsPercentage={Number(analyticsData?.hrPerc)}
            statsDescription={t('than last month')}
            cardClassName="card-2"
            icon={<Dashicon2 />}
            unit=" hrs"
          />
          <DashboardCard
            label={isRoomBooking ? t('total bookings') : t('total appointments')}
            value={formatValue({
              value:
                '' +
                Number(
                  analyticsData?.totalAppointmentCount ? analyticsData?.totalAppointmentCount : 0
                ).toFixed(),
              groupSeparator: ',',
              decimalSeparator: '.',
              prefix: '',
            })}
            statsPercentage={Number(analyticsData?.totalAppPerc)}
            statsDescription={t('than last month')}
            cardClassName="card-3"
            icon={<Dashicon3 />}
            unit=""
          />
          <DashboardCard
            label={isRoomBooking ? t('bookings completed') : t('appointments completed')}
            value={formatValue({
              value:
                '' +
                Number(
                  analyticsData?.appointmentCount ? analyticsData?.appointmentCount : 0
                ).toFixed(),
              groupSeparator: ',',
              decimalSeparator: '.',
              prefix: '',
            })}
            statsPercentage={Number(analyticsData?.appPerc)}
            statsDescription={t('than last month')}
            cardClassName="card-4"
            icon={<Dashicon4 />}
            unit=""
          />
        </div>
      )}
    </div>
  );
};

export type DashboardCardProps = {
  label: string;
  value?: string;
  statsPercentage: number;
  statsDescription: string;
  icon: JSX.Element;
  cardClassName: string;
  unit: string;
};
export const DashboardCard = ({
  label,
  value,
  statsDescription,
  statsPercentage,
  icon,
  cardClassName,
  unit,
}: DashboardCardProps) => {
  return (
    <div className={`dashbaord-card ${cardClassName}`}>
      <div className="dash-card-title">{label}</div>
      <div className="dash-info-data">
        <div className="dash-icon-bg">{icon}</div>
        <div>
          <div className="dash-count">
            <span>{value}</span>
            <span className="light-count">{unit}</span>
          </div>
        </div>
      </div>
      {/* <div className="dash-count-sm">
        <span className={statsPercentage > 0 ? 'green-c' : 'red-c'}>
          {statsPercentage > 0 ? '+' : ''} {statsPercentage}%{' '}
        </span>
        <span>{statsDescription}</span>
      </div> */}
    </div>
  );
};
